
import { domains } from "../../../../constants";

export const errorMessage = {
    "INVALID_USER": {
        "errorHeading": "Invalid User",
        "errorDescription": "Please check the username and password.",
        "loginPageRedirect": `Here's a link back to the <a href="https://login.${domains.learnship[process.env.REACT_APP_ENV]}">Login</a> page.`
    }
}